import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Card, CardBody } from 'reactstrap'

import ListTopBar from '../../components/ListTopBar'

import CouponsTable from './partials/CouponsTable'

import { handleError, parsePagination } from '../../helpers'
import { getCoupons } from './services'

export default function CouponsList() {
	const { user } = useSelector(state => state.auth)
	const [coupons, setCoupons] = useState(null)
	const [filterType, setFilterType] = useState('sku')
	const [filterValue, setFilterValue] = useState('')
	const [filterScope, setFilterScope] = useState('')
	const [pagination, setPagination] = useState({page: 1, per_page: 15, total: 0})
	const history = useHistory()

	useEffect(() => {
		!coupons && getCoupons({
			...pagination,
			'filter[employee_id]': user.id,
			[`filter[${filterType}]`]: filterValue,
			[filterScope ? `filter[${filterScope}]` : 'noscope']: 1,
			include: 'employee,couponType',
			sort: '-order'
		})
			.then(res => {
				setCoupons(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [ coupons, pagination, filterType, filterValue, filterScope, user ])

	return (
		<React.Fragment>
			<ListTopBar 
				title="Listado de Cupos Disponibles"
				subtitle="Consulta los cupos para compra asignados a su usario"
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				filterScope={filterScope}
				setFilterScope={setFilterScope}
				reload={() => setCoupons(null)}
				options={[
					{ label: 'Buscar por identificador', value: 'sku' },
				]}
				scopes={[
					{ label: 'Cupos válidos', value: 'valid' },
					{ label: 'Cupos vencidos', value: 'expired' },
					{ label: 'Cupos utilizados', value: 'used' },
					{ label: 'Cupos anulados', value: 'voided' },
				]}
				ctaText="Redimir Cupo"
				handleCtaClick={() => history.push('/coupon_orders/new')}
			/>
			<Card>
				<CardBody>
					<CouponsTable 
						coupons={coupons}
						reload={() => setCoupons(null)}
						pagination={pagination}
						setPagination={setPagination}
					/>
				</CardBody>
			</Card>
		</React.Fragment>
	)
}